import { useSearchParams } from 'react-router-dom'
import { PageHeader, Screen } from '../../components/chow'
import { useBackNav, useChooseChow } from '../choosechow/ChooseChowContext'
import { PromotionsPanel } from './PromotionsPanel'
import { OpsRatesPanel } from '../ops/OpsRatesPanel'
import { OpsFeePanel } from '../ops/OpsFeePanel'
import * as S from '../ops/OpsStyle'

export const OpsPromotionsPage = () => <>
  <div><S.H1>Fees & offers</S.H1><S.Lede>Set the service fee for new kitchen orders, then manage discounts.</S.Lede></div>
  <OpsFeePanel />
  <PromotionsPanel />
  <details><summary>Chef meal-plan package rates</summary><OpsRatesPanel /></details>
</>

export const ChefPromotionsPage = () => {
  const { profileId } = useChooseChow()
  const back = useBackNav()
  const [params] = useSearchParams()
  return <Screen header={<PageHeader title="Kitchen promotions" onBack={back} />}>
    <PromotionsPanel chefProfileId={profileId} initialDish={params.get('dish') ?? ''} />
  </Screen>
}
